module.exports = __webpack_public_path__ + "media/roomBgm.dfb3477d.mp3";